import { render, staticRenderFns } from "./ThematicDiscussionDetial.vue?vue&type=template&id=189824b4&scoped=true"
import script from "./ThematicDiscussionDetial.vue?vue&type=script&lang=js"
export * from "./ThematicDiscussionDetial.vue?vue&type=script&lang=js"
import style0 from "./ThematicDiscussionDetial.vue?vue&type=style&index=0&id=189824b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189824b4",
  null
  
)

export default component.exports